import { Drawer } from 'antd';
import { useUnit } from 'effector-react';
import {
  $mobilePopup,
  resetMobilePopupEv,
} from '../../models/centerHomeModel/index.js';
import CenterHomeListPopup from './CenterHomeListPopup.jsx';
import CenterHomePopup from './CenterHomePopup.jsx';

function CenterHomeMobilePopup() {
  const mobilePopup = useUnit($mobilePopup);
  const resetMobilePopup = useUnit(resetMobilePopupEv);

  const onClose = () => {
    const { _data } = window.map.getSource('ch_active_points_source');
    if (_data.features.length !== 0) {
      window.map.setFeatureState(
        { source: 'ch_points_source', id: _data.features[0].id },
        { active: false }
      );
      window.map.getSource('ch_active_points_source').setData({
        type: 'FeatureCollection',
        features: [],
      });
    }
    resetMobilePopup();
  };

  if (!mobilePopup) return;

  return (
    <Drawer
      placement="bottom"
      open={!!mobilePopup}
      closable={false}
      maskClosable
      onClose={onClose}
      styles={{ body: { padding: 16 } }}
    >
      {mobilePopup.length > 1 ? (
        <CenterHomeListPopup features={mobilePopup} closeable={false} />
      ) : (
        <CenterHomePopup feature={mobilePopup[0]} popup={false} />
      )}
    </Drawer>
  );
}

export default CenterHomeMobilePopup;
